import { render } from "./foundationSection.vue?vue&type=template&id=1f5abf9e"
import script from "./foundationSection.vue?vue&type=script&lang=js"
export * from "./foundationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__